<template>
    <Top />
    <!-- Spinner Start -->
    <!-- Spinner Start -->
    <div id="spinner" style="background-color: #DCDCDC;z-index: 999999;opacity: 0.5;" v-if="halamanloading"
        class="show position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <img src="../../../../src/assets/images/logo.png" height="40">&nbsp;
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
        </div>
        &nbsp;<span class="sr-only text-danger" style="font-weight: bolder;">..CISP System Loading...</span>
    </div>
    <div id="myModal" class="modal">
        <span class="close">&times;</span>
        <img class="modal-content" id="img01">
        <div id="caption"></div>
    </div>
    <!-- Spinner End -->
    <section class="hero-section d-flex justify-content-center align-items-center" id="section_1"
        :style="'background-image:url(' + folder_slider + foto_background + ') !important;'">
        <div class="section-overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-12 mb-5 mb-lg-0">
                    <h5 class="text-white">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">{{ nama }}&nbsp;</span>
                        <span v-else>{{ nama_eng }}&nbsp;</span>
                    </h5>
                    <h1 class="cd-headline rotate-1 text-white mb-4 pb-2">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">{{ text_label }}&nbsp;</span>
                        <span v-else>{{ text_label_eng }}&nbsp;</span>
                        <span v-if="(bahasa === null) || (bahasa == 'ina')" class="cd-words-wrapper">
                            <template v-for="(dataketerangan, urutketerangan) in keterangan" :key="urutketerangan">
                                <b :class="[((urutketerangan == 0) ? 'is-visible' : '')]">{{ dataketerangan.nama }}</b>
                            </template>
                        </span>
                        <span v-else class="cd-words-wrapper">
                            <template v-for="(dataketerangan_eng, urutketerangan_eng) in keterangan_eng"
                                :key="urutketerangan_eng">
                                <b :class="[((urutketerangan_eng == 0) ? 'is-visible' : '')]">{{ dataketerangan_eng.nama
                                    }}</b>
                            </template>
                        </span>
                    </h1>
                </div>
            </div>
        </div>

        <svg xmlns="" viewBox="0 0 1440 320">
            <path fill="#ffffff" fill-opacity="1"
                d="M0,224L34.3,192C68.6,160,137,96,206,90.7C274.3,85,343,139,411,144C480,149,549,107,617,122.7C685.7,139,754,213,823,240C891.4,267,960,245,1029,224C1097.1,203,1166,181,1234,160C1302.9,139,1371,117,1406,106.7L1440,96L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z">
            </path>
        </svg>
    </section>
    <section class="about-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-12 me-auto mb-4 mb-lg-0" style="display: none;">
                    <div class="row g-4 justify-content-center">
                        <div class="col-sm-12 float-left pb-2 px-3 wow fadeInDown">
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">Jumlah Data Berita:</span> <span
                                v-else>Number
                                of News Data:</span> {{ G_numFormat(jumlahdata) }}
                            <span style="float: right;">
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Halaman ke: </span> <span
                                    v-else>Page
                                    no:
                                </span><select v-model="halaman" @change="onChangeHalaman($event)">
                                    <option v-for="index in jumlahhalaman" :key="index">
                                        {{ index }}</option>
                                </select> <span v-if="(bahasa === null) || (bahasa == 'ina')"> dari </span> <span
                                    v-else>
                                    from
                                </span> {{ jumlahhalaman }}
                            </span>
                        </div>
                        <div class="col-sm-12 float-left pb-2">
                            <div class="input-group mb-3">
                                <input id="carikata" v-model="carikata"
                                    placeholder="Masukkan Kata Kunci Pencarian / Enter Search Keywords" type="text"
                                    class="form-control form-control-sm" style="font-size: small !important;"
                                    @change="ambildata()">
                                <div class="input-group-append">
                                    <span class="input-group-text" @click="ambildata()" style="cursor: pointer;"><i
                                            class="fas fa-search"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section class="about-section section-padding" id="section_2">
                    <div class="container">
                        <div class="row" v-for="(beranda, urutberanda) in databeranda" :key="urutberanda">
                            <div class="col-lg-4 col-md-6 col-12 mb-4 mb-lg-0 mb-md-0">
                                <div class="member-block">
                                    <div class="member-block-image-wrap">
                                        <img :id="beranda.id" :src="folder_foto + beranda.filenya_berita"
                                            v-if="(bahasa === null) || (bahasa == 'ina')"
                                            class="member-block-image img-fluid" :alt="beranda.kontenfull">
                                        <img :id="beranda.id" :src="folder_foto + beranda.filenya_berita" v-else
                                            class="member-block-image img-fluid" :alt="beranda.konten_eng_full">
                                        <ul class="social-icon">
                                            <li class="social-icon-item">
                                                <a href="#" class="social-icon-link bi-twitter"></a>
                                            </li>

                                            <li class="social-icon-item">
                                                <a href="#" class="social-icon-link bi-whatsapp"></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8 col-12 me-auto mb-4 mb-lg-0">
                                <h3 class="mb-3">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        {{ beranda.nama }}
                                    </span>
                                    <span v-else>
                                        {{ beranda.nama_eng }}
                                    </span>
                                </h3>
                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                    <span v-html="beranda.kontenfull"></span>
                                </span>
                                <span v-else>
                                    <span v-html="beranda.konten_eng_full"></span>
                                </span>
                                <a href="javascript:void(0)"
                                    class="btn btn-primary rounded-pill text-white py-2 px-4 mb-1"
                                    @click="ambilgambar(beranda.id)">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Mulai Simulasi
                                    </span>
                                    <span v-else>
                                        Start Simulation
                                    </span>
                                </a>
                            </div>
                            <div class="col-lg-12 col-md-6 col-12 mb-4 mb-lg-0 mb-md-0">&nbsp;</div>
                        </div>
                    </div>
                </section>
                <div class="col-lg-12 col-md-6 col-12 mb-4 mb-lg-0 mb-md-0">&nbsp;</div>
            </div>
        </div>
    </section>
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import 'vue3-carousel/dist/carousel.css'
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal
    },
    data() {
        return {
            halamanloading: true,
            carikata: '',
            databeranda: [],
            datapesan: '',
            datamaster: [],
            tahun: new Date().getFullYear(),
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_berita-Gambar?f=',
            jumlahdata: 0,
            jumlahhalaman: 0,
            mulai: 0,
            halaman: 1,
            nama: '',
            nama_eng: '',
            text_label: '',
            text_label_eng: '',
            keterangan: [],
            keterangan_eng: [],
            folder_slider: process.env.VUE_APP_URL_API + 'parastapainnovation_slider-Gambar?f=',
            foto_background: '',
            bahasa: localStorage.getItem("bahasasistem"),
            project_id: process.env.VUE_APP_PROJECT_ID,
        };
    },
    methods: {
        ambilgambar(id) {
            alert('on progress');
        },
        async caridata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            //alert(this.carikata);
            this.halamanloading = true;
            var random = Math.random();
            await mainAPI.get("parastapainnovation-GetBerita?random=" + random + "&nama=" + this.carikata + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        var datasementara = [];
                        this.databeranda = [];
                        datasementara = Response.data.content.data;
                        datasementara.forEach((item) => {
                            this.databeranda.push({
                                id: item.id,
                                nama: item.nama,
                                tanggal: item.tanggal,
                                nama_eng: item.nama_eng,
                                konten: item.isi,
                                konten_eng: item.isi_eng,
                                kontenfull: item.isi,
                                konten_eng_full: item.isi_eng,
                                filenya_berita: item.filenya_berita,
                            });
                        });
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                    }
                    else {
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                this.datamaster = [];
                this.slides = [];
                console.log(error);
                this.halamanloading = false;
            });
        },
        onChangeHalaman(event) {
            this.pindahhalaman(event.target.value);
        },
        async pindahhalaman(halamannya) {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

            this.halamanloading = true;
            var random = Math.random();
            await mainAPI.get("parastapainnovation-GetBerita?random=" + random + "&halaman=" + halamannya + "&nama=" + this.carikata + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        var datasementara = [];
                        this.databeranda = [];
                        datasementara = Response.data.content.data;
                        datasementara.forEach((item) => {
                            this.databeranda.push({
                                id: item.id,
                                nama: item.nama,
                                tanggal: item.tanggal,
                                nama_eng: item.nama_eng,
                                konten: (item.isi),
                                konten_eng: (item.isi_eng),
                                kontenfull: item.isi,
                                konten_eng_full: item.isi_eng,
                                filenya_berita: item.filenya_berita,
                            });
                        });
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                    }
                    else {
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                this.datamaster = [];
                this.slides = [];
                console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });

            this.halamanloading = true;
            var random = Math.random();
            await mainAPI.get("parastapainnovation-GetBerita?random=" + random + "&project_id=" + this.project_id + "&nama=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        var datasementara = [];
                        this.databeranda = [];
                        datasementara = Response.data.content.data;
                        datasementara.forEach((item) => {
                            this.databeranda.push({
                                id: item.id,
                                nama: item.nama,
                                tanggal: item.tanggal,
                                nama_eng: item.nama_eng,
                                konten: (item.isi),
                                konten_eng: (item.isi_eng),
                                kontenfull: item.isi,
                                konten_eng_full: item.isi_eng,
                                filenya_berita: item.filenya_berita,
                            });
                        });
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                    }
                    else {
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                this.datamaster = [];
                this.slides = [];
                //console.log(error);
                this.halamanloading = false;
            });

            this.halamanloading = true;
            var random = Math.random();
            await mainAPI.get("parastapainnovation-GetSlider?random=" + random + "&project_id=" + this.project_id + "&id=3").then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.dataslider = [];
                        this.dataslider = Response.data.content.data;
                        this.nama = Response.data.content.data[0].nama;
                        this.nama_eng = Response.data.content.data[0].nama_eng;
                        this.text_label = Response.data.content.data[0].text_label;
                        this.text_label_eng = Response.data.content.data[0].text_label_eng;
                        this.keterangan = Response.data.content.data[0].keterangan;
                        this.keterangan_eng = Response.data.content.data[0].keterangan_eng;
                        this.foto_background = '';
                        this.foto_background = Response.data.content.data[0].filenya_slider;
                        this.halamanloading = false;
                    }
                    else {
                        this.dataslider = [];
                        this.foto_background = '';
                        this.halamanloading = false;
                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.foto_background = '';
                this.dataslider = [];
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style>
.carousel__prev,
.carousel__next {
    box-sizing: content-box;
    border: 5px solid #0055aa;
    border-radius: 40px;
    background-color: #0055aa;
    color: aliceblue;
    height: 50px;
    width: 50px;
}

/* The Modal (background) */
.modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 888888;
    /* Sit on top */
    padding-top: 20px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(251, 248, 248, 0.9);
    /* Fallback color */
    background-color: rgb(251, 248, 248, 0.9);
    /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    float: left;
    margin-right: 10px;
    margin-left: 60px;
}

/* Caption of Modal Image */
#caption {
    margin: auto;
    display: block;
    width: 90%;
    max-width: 90%;
    text-align: justify;
    color: #111;
    padding: 10px 0;
}

/* Add Animation */
.modal-content,
#caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
    from {
        -webkit-transform: scale(0)
    }

    to {
        -webkit-transform: scale(1)
    }
}

@keyframes zoom {
    from {
        transform: scale(0)
    }

    to {
        transform: scale(1)
    }
}

/* The Close Button */
.close {
    position: absolute;
    top: 20px;
    right: 35px;
    color: #111;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
    z-index: 99999;
}

.close:hover,
.close:focus {
    color: #111;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
    .modal-content {
        width: 100%;
    }
}

.gambar:hover {
    cursor: pointer;
    opacity: 0.5;
}
</style>